import axios from 'axios'
import router from '../router'

let moment = require("moment");
let md5 = require("md5");

const myRouters = router
const token = "5ec05e13005d15d03d39d4868b5677fe"
// sms-homo.corporeadministradora.com.br
// app-homo.corporeadministradora.com.br
// www-homo.corporeadministradora.com.br
//http://api.corporeadministradora.com.br:8888
const actions = {
  async doRequest({ commit, dispatch }, obj) {
    let baseURL = (obj.api == 'criare') ? process.env.VUE_APP_URL_API : process.env.VUE_APP_URL
    if (obj.api == 'irpf') {
      baseURL = process.env.VUE_APP_URL_IRPF
    }
    if (obj.api == 'newSite') {
      baseURL = process.env.VUE_APP_URL_NEW_SITE
    }
    obj.url = baseURL + obj.url
    const _this = this
    if (!actions.verifyAuth() && myRouters.history.current.path != '/login' && myRouters.history.current.path != '/2aviaboletos' && myRouters.history.current.path != '/cadastro') {
      dispatch('logout')
    }
    if (obj && !obj.noLoader) {
      this.commit('showLoader', {
        circle: true
      })
    }
    obj.query.pin = localStorage.alltechPIN;
    let returnRequestData = await axios[(obj.method ? obj.method : 'get')](obj.url, obj.query)
      .then(response => {
        if (!obj.noLoader) {
          _this.commit('hideLoader')
        }
        console.log('doreq')
        return response || ''
      })
      .catch(error => {
        console.log('doreq2')
        if (obj.returnError) {
          if (!obj.noLoader) {
            _this.commit('hideLoader')
          }
          return error
        }

        if (error.response && (error.response.status == 401 || error.response.status == 503)) {
          dispatch('logout')
        }

        let paramModal = {}
        paramModal.title = 'Ocorreu erro'
        paramModal.type = 'error'
        paramModal.callback = null
        paramModal.message = error.response.data.message
        // paramModal.message = error.response ?
        //   (error.response.data.errors ? Object.values(error.response.data.errors).join('<br>')
        //     : (error.response.data.message)) : 'Contate o administrador do sistema'
        // paramModal.title = 'Ocorreu erro'
        // paramModal.type = 'error'
        // if (obj && obj.url.indexOf('irpf') < 0) {
        //   paramModal.callback = () => { myRouters.push("/login") }
        // } else {
        //   let irpfMessage = paramModal.message
        //   let allIrpfReports = []
        //   _this.commit('irpf/saveIrpfReports', { irpfMessage, allIrpfReports })
        //   console.log(_this.state.irpf.irpfMessage);
        //   paramModal.callback = null
        // }

        paramModal.btConfirm = {
          name: 'Ok',
          show: true
        }
        paramModal.btCancel = {
          show: false
        }
        _this.commit('hideLoader')
        _this.commit('confirmMessage/showConfirmMessage', paramModal)
        return error.response
      })
    return returnRequestData
  },
  async addressByZipcode(state, zipcode) {
    const _this = this
    let url = 'https://viacep.com.br/ws/' + zipcode + '/json/'
    let address
    delete axios.defaults.headers["Authorization"];
    await axios.get(url).then(response => {
      address = response.data
    }).catch(error => {
      let paramModal = {}
      paramModal.message = error.response ? (error.response.data.errors ? Object.values(error.response.data.errors).join('<br>') : (error.response.data.message)) : 'Contate o administrador do sistema'
      paramModal.title = 'Ocorreu erro'
      paramModal.type = 'error'
      paramModal.btConfirm = {
        name: 'Ok',
        show: true
      }
      paramModal.btCancel = {
        show: false
      }
      _this.commit('confirmMessage/showConfirmMessage', paramModal)
    })
    return address
  },
  verifyAuth() {
    let now = new Date().getTime()
    if (localStorage.corporeToken && localStorage.corporeExpireToken > now) {
      return true
    } else {
      return false
    }
  },
  async doLogin({ dispatch }, opts) {
    const _this = this
    opts.token = token
    let obj = {
      url: '/corpore/wscorp.dll/datasnap/rest/tsmadesao/login',
      query: { ...opts },
      method: 'post'
    }
    await dispatch('doRequest', obj).then(resp => {

      if (resp.data.result == "ERROR") {
        return ['error', resp.data.mensagem]
      }
      let userData = {
        status: resp.status,
        token: resp.data.kw,
        cpf: opts.cpf,
        expireToken: new Date().getTime() + 2 * 60 * 60 * 1000
      }
      localStorage.corporeToken = userData.token
      localStorage.corporeExpireToken = userData.expireToken
      localStorage.corporeUserId = userData.cpf
      return userData

    }).then(userData => {
      if (userData[0] == 'error') {
        let paramModal = {}
        paramModal.message = userData[1]
        paramModal.title = 'Ocorreu erro'
        paramModal.type = 'error'
        paramModal.btConfirm = {
          name: 'Ok',
          show: true
        }
        paramModal.btCancel = {
          show: false
        }
        _this.commit('confirmMessage/showConfirmMessage', paramModal)
        return 'error'
      }
      if (userData.status >= 400) { return }
      dispatch('getUserPlans', userData).then(_ => {
        _this.commit('toggleMenu', 'hide')
        myRouters.push('/')
        return true
      })
    })

  },
  async activationCode({ dispatch }, params) { // API MATEUS
    let userData = null
    let obj = {
      url: 'send-code',
      query: params,
      method: 'post',
      api: 'criare'
    }
    await dispatch('doRequest', obj).then(resp => {
      console.log('send-code')
      if (resp && resp.data) {
        userData = resp.data
        userData.status = resp.status
      }
      return userData
    })
    return userData
  },
  async activateUser({ dispatch }, params) {
    params.token = token
    let userData = null
    let obj = {
      url: '/corpore/wscorp.dll/datasnap/rest/tsmadesao/activateuser',
      query: params,
      method: 'post'
    }
    await dispatch('doRequest', obj).then(resp => {
      if (resp) {
        userData = resp.data
        userData.status = resp.status
      } else {
        userData = 'error'
        let paramModal = {}
        paramModal.message = resp.data.mensagem
        paramModal.title = 'Ocorreu erro'
        paramModal.type = 'error'
        paramModal.btConfirm = {
          name: 'Ok',
          show: true
        }
        paramModal.btCancel = {
          show: false
        }
        _this.commit('confirmMessage/showConfirmMessage', paramModal)
      }
      return userData
    })
    return userData
  },
  async getUserData({ dispatch }, cpf) {
    let userData = null
    let PIN =
      "PN" +
      cpf.replace(/\D/g, "") +
      "@" +
      moment(new Date()).format("YYYYMMDD");
    localStorage.alltechPIN = md5(PIN);
    let params = {
      cpf: cpf,
      pin: PIN
    }
    let obj = {
      url: '/corpore/wscorp.dll/datasnap/rest/tsmadesao/usercontact',
      query: { ...params },
      method: 'post'
    }
    await dispatch('doRequest', obj).then(resp => {
      // console.log('passo1')
      if (resp) {
        userData = resp.data
        return userData
      }
    })
    return userData
  },
  async getUserPlans({ commit, dispatch }, opts) {
    let _this = this
    let planos = []
    console.log('kw storage')
    let params = {
      cpf: opts.cpf,
      kw: localStorage.kwTk ? localStorage.kwTk : opts.token
    }
    let obj = {
      url: '/corpore/wscorp.dll/datasnap/rest/tsmadesao/beneficiario',
      query: { ...params },
      method: 'post'
    }
    await dispatch('doRequest', obj).then(plans => {
      if (plans.data.quantidade == 0 || plans.data.planos.length == 0) {
        let paramModal = {}
        paramModal.message = plans.data.mensagem
        paramModal.title = 'Ocorreu erro'
        paramModal.type = 'error'
        paramModal.callback = () => { dispatch('logout') }
        paramModal.btConfirm = {
          name: 'Ok',
          show: true
        }
        paramModal.btCancel = {
          show: false
        }
        _this.commit('confirmMessage/showConfirmMessage', paramModal)
        return 'error'

      } else {
        planos = plans.data.planos
      }
    })
    this.commit('plans/savePlans', planos, { root: true })
    return true
  },
  logout() {
    localStorage.clear();
    this.state.plans.plans = [];
    this.commit('plans/savePlans', [], { root: true })
    setTimeout(() => {
      this.commit('toggleMenu', 'hide')
      myRouters.push("/login")
    }, 200)
    return true
  }
}

export default {
  namespaced: true,
  root: true,
  actions
}
